import {Component, OnInit} from '@angular/core';
import {
  LighthouseBrandListDisplayItem, LighthouseEndpointListDisplayItem,
  LighthousePortalListDisplayItem
} from '@shared-library';
import {ConfigService} from '@shared-library';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';

@Component({
    selector: 'app-health-system-brand-details',
    templateUrl: './health-system-brand-details.component.html',
    styleUrls: ['./health-system-brand-details.component.css'],
    standalone: false
})
export class HealthSystemBrandDetailsComponent implements OnInit {

  constructor(
    public configService: ConfigService,
    public router: Router,
    private logger: NGXLogger,
  ) {}

  ngOnInit(): void {
  }

  addPendingAccount(brand: LighthouseBrandListDisplayItem, portal: LighthousePortalListDisplayItem, endpoint: LighthouseEndpointListDisplayItem){
    this.logger.debug("connecting", brand, portal, endpoint)
    // this.configService.vaultProfileAddPendingAccount(brand, portal, endpoint)

    this.router.navigate(['brand/connecting'], {
      queryParams: {
        "brandId": brand?.id,
        "portalId": portal?.id,
        "endpointId": endpoint?.id,
        "externalId": this.configService.systemConfig$.externalId,
      }
    })

  }
}
